module.exports = __webpack_public_path__ + "h5/img/bs_03.88f97986.jpeg";